import React from 'react';

export const AnalyzeTasks = () => <h1 className="pageTitle">Tasks</h1>;
